export const createReducer = (initState, events) => (
  state = initState,
  action,
) => {
  if (events[action.type]) {
    return events[action.type].handler(state, action);
  }
  return state;
};
